module.exports = "http://edflaborworks.com:8022"


// WEBPACK FOOTER //
// ./src/host.js